"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueField = void 0;
var ValueField;
(function (ValueField) {
    ValueField["goldPreis"] = "goldPreis";
    ValueField["silberPreis"] = "silberPreis";
    ValueField["platinPreis"] = "platinPreis";
    ValueField["palladiumPreis"] = "palladiumPreis";
    ValueField["kalkulationsfaktor"] = "kalkulationsfaktor";
})(ValueField = exports.ValueField || (exports.ValueField = {}));
//# sourceMappingURL=ValueField.js.map